module.exports = __webpack_public_path__ + "static/media/que-hacer-en-palermo.cbf32e70.md";